import { months } from "@jeffcarbine/premmio/public/modules/months/months.js";
import { formatSimpleDate } from "@jeffcarbine/premmio/public/modules/formatDate/formatDate.js";
import { formatTimeString } from "@jeffcarbine/premmio/public/modules/formatTime/formatTime.js";
import { Icon } from "@jeffcarbine/premmio/public/components/icon/icon.html.js";

export const eventBoxTemplate = (event) => {
  const soldOut = event.soldOut !== undefined ? event.soldOut : false;

  const eventElement = {
    class: "event",
    id: "_" + event._id,
    "data-vclass": "visible",
    children: [
      {
        class: "location-title",
        children: [
          {
            class: "flag-container",
            child: {
              tagName: "img",
              class: "flag",
              src:
                "https://doih87m1dc6d2.cloudfront.net/images/flags/" +
                event.country.toLowerCase() +
                ".webp",
              alt: event.country,
            },
          },
          {
            class: "city-title",
            children: [
              {
                tagName: "h2",
                class: "city",
                textContent: event.city,
                child: {
                  tagName: "span",
                  textContent:
                    (event.region !== "" ? event.region + ", " : "") +
                    event.country,
                },
              },
              {
                if: event.title !== undefined && event.title !== "",
                class: "title",
                child: {
                  tagName: "span",
                  textContent: event.title,
                },
              },
            ],
          },
        ],
      },
      {
        class: "details",
        children: [
          {
            class: "date",
            child: {
              tagName: "h3",
              textContent: formatSimpleDate(event.date),
              child: {
                tagName: "span",
                textContent: formatTimeString(event.time),
              },
            },
          },
          {
            class: "venue",
            children: [
              {
                if: event.venue !== null && event.venue !== "",
                tagName: "h4",
                class: "venueName",
                textContent: event.venue,
              },
              {
                if: event.venue !== null && event.venue !== "",
                class: "address",
                children: [
                  {
                    tagName: "p",
                    children: [
                      new Icon("mapMarker"),
                      {
                        tagName: "span",
                        textContent: event.street,
                      },
                    ],
                  },
                ],
              },
              {
                if: event.venue === null || event.venue === "",
                tagName: "h4",
                class: "tba",
                textContent: "TBA!",
              },
            ],
          },
        ],
      },
      {
        class: "actions",
        children: [
          {
            if: event.tickets !== null && event.tickets !== "",
            class: "btn-centered",
            child: {
              tagName: soldOut ? "span" : "a",
              href: soldOut ? null : event.tickets,
              target: soldOut ? null : "blank",
              class: "btn " + (soldOut ? "hasMessage" : ""),
              textContent: "Buy Tickets",
              child: {
                if: soldOut,
                tagName: "span",
                class: "message",
                textContent: "Sold out!",
              },
            },
          },
          {
            if: soldOut,
            tagName: "a",
            class: "resell",
            href: "/faqs?openaccordion=tickets",
            textContent: "Can I still get tickets?",
          },
          {
            if:
              !soldOut &&
              (event.tickets === null ||
                event.tickets === undefined ||
                event.tickets === ""),
            class: "availableSoon",
            textContent: "Tickets Available Soon!",
          },
        ],
      },
    ],
  };

  return eventElement;
};

// -const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
// .event(id="_" + event._id, data-vclass="visible")
//   h2.city #{event.city}
//     span
//       if(event.region !== "")
//         | #{event.region},
//       | #{event.country}
//   .details
//     .date
//       h3 #{months[event.date.getMonth()]} #{event.date.getDate()}
//         span #{event.date.getFullYear()}
//     .venue
//       if(event.venue !== null && event.venue !== "")
//         h4.venueName #{event.venue}
//         p #{event.street}
//         //- if(event.festival !== "")
//         //-   span #{event.festival}
//       else
//         h4.tba TBA!
//   .actions
//     .btn-centered
//       if(event.tickets !== null && event.tickets !== "")
//         if(soldOut)
//           span.btn.soldOut Buy Tickets
//             span.message Sold Out!
//         else
//           a.btn(href=event.tickets, target="blank") Buy Tickets
//         //- if(isHomepage)
//         //-   a.btn(href="/live#" + event._id) More Info
//     if(soldOut)
//       a.resell(href="/faqs?openaccordion=tickets") Can I still get tickets?
//     //- if(!isHomepage)
//     //-   .map-container
//     //-     .event-map(data-longitude=event.longitude, data-latitude=event.latitude)
